import './style/index.js';

import _Button from './Button';

export type { ButtonProps } from './Button';
export * from './type';

export const Button = _Button;
export default Button;
